/* eslint-disable no-undef */
import { useState, useEffect } from "react";
import { getPreviewLinkList } from "../services/previews";
import { useLocation } from "react-router-dom";
import { ArrowForward as ArrowForwardIcon } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { displayErrorFeedback } from "../app/feedbackSlice";
import { getAverageColorFromBorders } from "../utils/functions";
import {
  Container,
  Header,
  HeaderInner,
  Logo,
  ProjectCount,
  Hero,
  Title,
  ProjectList,
  ProjectItem,
  ProjectLink,
  ProjectIndex,
  Thumbnail,
  ProjectNames,
  ClientName,
  ProjectName,
  Arrow,
  Footer,
  SubContainerLogos,
  LogoAgency,
  EdgLogo,
} from "./styles/Preview.styled";

const ProjectRow = ({ project, index }) => {
  const visualPath = project.clientVisualPath ? `${process.env.REACT_APP_PROXY}/assets/clients/${project.clientVisualPath}` : null;
  const [thumbnailColor, setThumbnailColor] = useState("#FFFFFF");

  useEffect(() => {
    if (!visualPath) return;
    let isMounted = true;
    // Thumbnail background matches the logo's borders so the logo blends in
    getAverageColorFromBorders(visualPath, "#FFFFFF").then((color) => isMounted && setThumbnailColor(color));
    return () => {
      isMounted = false;
    };
  }, [visualPath]);

  return (
    <ProjectItem $index={index}>
      <ProjectLink href={project.projectPreviewLink} target="_blank" rel="noreferrer">
        <ProjectIndex>{String(index + 1).padStart(2, "0")}</ProjectIndex>
        <Thumbnail $backgroundColor={thumbnailColor}>{visualPath && <img src={visualPath} alt="" />}</Thumbnail>
        <ProjectNames>
          {project.clientName && <ClientName>{project.clientName}</ClientName>}
          {project.projectName && <ProjectName>{project.projectName}</ProjectName>}
        </ProjectNames>
        <Arrow>
          <ArrowForwardIcon />
        </Arrow>
      </ProjectLink>
    </ProjectItem>
  );
};

export default function PreviewsPage() {
  const [data, setData] = useState([]);
  const [agency, setAgency] = useState(null);
  const location = useLocation();
  const dispatch = useDispatch();

  const getPreviewList = async () => {
    const searchProjectsParams = new URLSearchParams(location.search).get("id");
    if (!searchProjectsParams) return;
    try {
      const fetchedPreviewLinkList = await getPreviewLinkList(searchProjectsParams);
      const { previewLinkList, userAgency } = fetchedPreviewLinkList;
      setData(previewLinkList);

      if (userAgency) {
        setAgency(userAgency);
      }
    } catch (error) {
      console.error(error.message);
      setData([]);
      dispatch(displayErrorFeedback({ message: error.message || "Oops, an error occurred..." }));
    }
  };

  useEffect(() => {
    getPreviewList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <Header>
        <HeaderInner>
          {!!agency && <Logo src={`/api/assets/agencies/${agency.imgPath}`} alt={agency.name} />}
          {!!data.length && (
            <ProjectCount>
              {data.length} {data.length > 1 ? "projects" : "project"}
            </ProjectCount>
          )}
        </HeaderInner>
      </Header>
      <Hero>
        <Title>
          Selected
          <br />
          <span>projects.</span>
        </Title>
      </Hero>
      <ProjectList>
        <ul>
          {data.map((project, index) => (
            <ProjectRow key={`project-preview-${project.projectId}`} project={project} index={index} />
          ))}
        </ul>
      </ProjectList>
      <Footer>
        <SubContainerLogos>
          <a href="https://www.ores-group.com/?lang=fr" target="_blank" rel="noopener noreferrer">
            <LogoAgency src={`${process.env.REACT_APP_PROXY}/assets/agencies/ores-white.svg`} alt="Orès" width="100" />
          </a>
          <a href="https://kindai.fr/" target="_blank" rel="noopener noreferrer">
            <LogoAgency src={`${process.env.REACT_APP_PROXY}/assets/agencies/kindai.png`} alt="Kindai" width="50" />
          </a>
          <a href="https://digitalprod.com/" target="_blank" rel="noopener noreferrer">
            <LogoAgency src={`${process.env.REACT_APP_PROXY}/assets/agencies/logo-digitalprod.svg`} alt="Digital Prod" width="200" />
          </a>
          <a href="https://band-originale.com/" target="_blank" rel="noopener noreferrer">
            <LogoAgency src={`${process.env.REACT_APP_PROXY}/assets/agencies/bandoriginale.svg`} alt="Band Originale" width="100" />
          </a>
          <a href="https://www.ghostsplaymusic.com/" target="_blank" rel="noopener noreferrer">
            <LogoAgency src={`${process.env.REACT_APP_PROXY}/assets/agencies/ghost.png`} alt="Ghost" width="100" />
          </a>
        </SubContainerLogos>
        <a href="https://www.europeandigital-group.com/" target="_blank" rel="noopener noreferrer">
          <EdgLogo src={`${process.env.REACT_APP_PROXY}/assets/agencies/we-are-edg.png`} alt="EDG" width="400" />
        </a>
      </Footer>
    </Container>
  );
}
